import loadable from "@loadable/component";
import { ErrorBoundary } from "../../components";
import FullPageLoader from "@Components/FullPageLoader";

const EsimPostPayment = loadable(() => import("./EsimPostPayment"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <EsimPostPayment {...props} />
  </ErrorBoundary>
);
